import React from "react";
import { Modal, Descriptions } from "antd";
import { getModalDims, formatDate } from "../LedgerResponsive";

export default function ClientModal({ open, record, onClose, screens }) {
  if (!record) return null;
  return (
    <Modal
      title="Client Details"
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      maskClosable={false}
      keyboard={true}
      {...getModalDims(screens)}
    >
      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label="Name">{record.invester_name}</Descriptions.Item>
        <Descriptions.Item label="PAN">{record.pan}</Descriptions.Item>
        <Descriptions.Item label="DOB">{formatDate(record.dob)}</Descriptions.Item>
        <Descriptions.Item label="Mobile">{record.mobile}</Descriptions.Item>
        <Descriptions.Item label="Email">{record.email}</Descriptions.Item>
        <Descriptions.Item label="Total Investment">₹{Number(record.total_investment || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Redemption Cost Amount">₹{Number(record.redemption_cost_amount || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Redemption Actual Amount">₹{Number(record.redemption_actual_amount || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Remaining Cost Value">₹{Number(record.remaining_cost_value || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Current Value">₹{Number(record.current_value || 0).toLocaleString()}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}
